import { h1, h2, p, strong, table, ol, wrapHTML, parseMarkdownFull } from './htmlUtils';

interface SuggestedKeyword {
  keyword: string;
  volume: number;
  cpc: string;
  currency?: string;
  competition: number;
}

/**
 * Format SEO Keyword Research data as HTML (matches SEOKeywordRenderer.tsx)
 */
export const formatSEOKeywordHTML = (data: any): string => {
  if (!data || (!data.suggested_keywords && !data.seo_title)) {
    return wrapHTML(p('No SEO keyword data available'));
  }

  const sections: string[] = [];

  // Header
  sections.push(h1('🔍 SEO Keyword Research'));

  // SEO Title
  if (data.seo_title) {
    sections.push(p(`${strong('SEO Title:')} ${data.seo_title}`));
  }

  // Meta Description
  if (data.meta_description) {
    sections.push(p(`${strong('Meta Description:')} ${data.meta_description}`));
  }

  // Suggested Keywords Table
  if (data.suggested_keywords && data.suggested_keywords.length > 0) {
    sections.push(h2(`Suggested Keywords (${data.suggested_keywords.length})`));

    const headers = ['Keyword', 'Volume', 'CPC', 'Competition'];
    const rows = data.suggested_keywords.map((keyword: SuggestedKeyword) => {
      const competitionPercent = (keyword.competition * 100).toFixed(0);

      return [
        keyword.keyword,
        keyword.volume.toLocaleString(),
        `${keyword.currency || '$'}${keyword.cpc}`,
        `${competitionPercent}%`,
      ];
    });

    sections.push(table(headers, rows));
  }

  // Top Competitors
  if (data.top_competitors && data.top_competitors.length > 0) {
    sections.push(h2(`Top Competitors (${data.top_competitors.length})`));
    sections.push(ol(data.top_competitors.map((competitor: string) => competitor)));
  }

  // Response Text / Analysis (with full markdown support like ReactMarkdown)
  if (data.response_text) {
    sections.push(h2('Analysis'));
    sections.push(parseMarkdownFull(data.response_text));
  }

  return wrapHTML(sections.join(''));
};
